import Vue from 'vue'

Vue.filter('percentage', data => {
  const percentage = data * 100

  if (Number.isInteger(percentage)) return `${percentage}%`

  return `${percentage.toFixed(2)}%`
})
